import { useEffect, useState } from "react"
import { Edit2, Eye, Link, Plus, Search, Trash2, X } from "react-feather"
import { useAuthState } from "../../../../helper/Context/context"
import { AdminHeader } from "../../AdminHeader"
import { AdminSidebar } from "../../../Private/MainDashboard/Sidebar/AdminSidebar"
import { Pegination } from "../../../../helper/Pegination/Pegination"
import { DummyDDL } from "../../../CommonDDL/DummyDDL/DummyDDL"
import { DeletePopup as DeletePopupModal } from "../../../CommonPopup/DeletePopup/DeletePopup"
import { ImageViewPopup } from "../../../CommonPopup/ImageViewPopup/ImageViewPopup"
import { TextViewPopup } from "../../../CommonPopup/TextViewPopup/TextViewPopup"
import { UpcomingSeminarPopup } from "./UpcomingSeminarPopup"
import { UpcomingSeminarViewPopup } from "./UpcomingSeminarViewPopup"
import { GET_M_SeminarMaster_SelectAPI, M_SeminarMaster_DeleteAPI } from "../../../../helper/Redux/Slices/Admin/SeminarMasterSlice/SeminarMasterSlice"
import { useSearchParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { LogoLoader } from "../../../../helper/Loaders/LogoLoader"
import { ExpandableText } from "../../../../helper/ExpandableText/ExpandableText"
import { getSelectedMonthDateRange } from "../../../../helper/DateRange/DateRange"
import moment from "moment"

export const UpcomingSeminar = () => {
    const [searchparams, setSearchParams] = useSearchParams()
    const ScreenName = searchparams.get('ScreenName')

    const dispatch = useDispatch();
    const userDetails = useAuthState();
    const { year, Month, Language } = userDetails;
    const { UserID, token } = userDetails.user;

    // console.log("Year", year.Label)
    // console.log("Month", Month.ID)

    // console.log("Language: ", Language);

    const [perPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [RowNo, setRowNo] = useState(1)
    const [currentPage, setCurrentPage] = useState(0)
    const [isOpen, setIsOpen] = useState(true)
    const [DeletePopup, setDeletePopup] = useState(false)
    const [deleteData, setDeleteData] = useState(null)
    const [loader, setLoader] = useState(false)
    const [isPost, setIsPost] = useState(false)
    const [imageViewUrl, setImageViewUrl] = useState("")
    const initialSearchTitle = searchparams.get("Search") || ""
    const [searchTitle, setSearchTitle] = useState(initialSearchTitle)
    const [appliedSearchTitle, setAppliedSearchTitle] = useState(initialSearchTitle)
    const initialFromDate = searchparams.get("FromDate") || ""
    const initialToDate = searchparams.get("ToDate") || ""
    const [fromDate, setFromDate] = useState()
    const [toDate, setToDate] = useState()
    const [appliedFromDate, setAppliedFromDate] = useState()
    const [appliedToDate, setAppliedToDate] = useState()
    const selectedMonthDateRange = getSelectedMonthDateRange(year?.Label, Month?.ID)

    useEffect(() => {
        const range = getSelectedMonthDateRange(year?.Label, Month?.ID)
        if (range.fromDate) {
            // setFromDate(range.fromDate)
            // setToDate(range.toDate)
            // setAppliedFromDate(range.fromDate)
            // setAppliedToDate(range.toDate)
        }
    }, [year?.ID, year?.Label, Month?.ID])

    // TextPopup
    const [textViewData, setTextViewData] = useState({
        show: false,
        title: "",
        text: "",
        links: [],
    })

    const openTextPopup = (title, url) => {
        setTextViewData({
            show: true,
            title,
            text: url,
            links: [{ label: "Open link", url }],
        })
    }

    // Upcoming Seminar Popup
    const [UpcomingSeminarHoldPopUp, setUpcomingSeminarHoldPopUp] = useState({
        show: false,
        data: "",
        screenType: "",
    })

    const handleUpcomingSeminarPopUp = (show, type, rowdata) => {
        setUpcomingSeminarHoldPopUp({
            show,
            data: rowdata || "",
            screenType: type,
        })
    }

    const handleUpcomingSeminarPopUpClose = () => {
        setUpcomingSeminarHoldPopUp({
            show: false,
            data: "",
            screenType: "",
        })
    }

    // Upcoming Seminar Popup
    const [upcomingSeminarViewPopup, setUpcomingSeminarViewPopup] = useState({
        show: false,
        data: "",
    })

    const handleUpcomingSeminarViewPopup = (item) => {
        setUpcomingSeminarViewPopup({
            show: true,
            data: item,
        })
    }

    const handleUpcomingSeminarViewPopupClose = () => {
        setUpcomingSeminarViewPopup({
            show: false,
            data: "",
        })
    }

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    useEffect(() => {
        handleGetData(appliedSearchTitle, appliedFromDate, appliedToDate)
    }, [year?.Label, Month?.ID, Language?.Label, isPost, appliedSearchTitle, appliedFromDate, appliedToDate])

    const handleGetData = (searchTerm = "", selectedFromDate = "", selectedToDate = "") => {

        const data = {
            SeminarID: 0,
            SearchTerm: searchTerm,
            FromDate: selectedFromDate,
            ToDate: selectedToDate,
            Flag: "Details",
            M_UserID: UserID,
            Language: Language?.Label,
            FromTop: 1,
            ToTop: perPageCount,
            token,
        }

        dispatch(GET_M_SeminarMaster_SelectAPI({ data }))

    }

    const handleSearch = () => {
        const value = searchTitle.trim()
        const selectedFromDate = fromDate
        const selectedToDate = toDate
        const nextSearchParams = new URLSearchParams(searchparams)

        if (value) {
            nextSearchParams.set("Search", value)
        } else {
            nextSearchParams.delete("Search")
        }

        if (selectedFromDate) {
            nextSearchParams.set("FromDate", selectedFromDate)
        } else {
            nextSearchParams.delete("FromDate")
        }

        if (selectedToDate) {
            nextSearchParams.set("ToDate", selectedToDate)
        } else {
            nextSearchParams.delete("ToDate")
        }

        setSearchParams(nextSearchParams, { replace: true })
        setAppliedSearchTitle(value)
        setAppliedFromDate(selectedFromDate)
        setAppliedToDate(selectedToDate)
    }

    const handleClearSearch = () => {
        const nextSearchParams = new URLSearchParams(searchparams)
        nextSearchParams.delete("Search")
        nextSearchParams.delete("FromDate")
        nextSearchParams.delete("ToDate")
        setSearchParams(nextSearchParams, { replace: true })
        setSearchTitle("")
        setFromDate("")
        setToDate("")
        setAppliedSearchTitle("")
        setAppliedFromDate("")
        setAppliedToDate("")
    }
    const { isLoading, TableData } = useSelector(
        (state) => state.GET_M_SeminarMaster_SelectData
    );

    const openPhoto = (photoUrl) => {
        if (photoUrl) {
            setImageViewUrl(photoUrl)
        }
    }

    const openLink = (url) => {
        if (url) {
            window.open(url)
        }
    }

    // Delete
    const handleDelete = (item) => {
        setDeleteData(item)
        setDeletePopup(true)
    }

    const handleDeleteClose = () => {
        if (!loader) {
            setDeletePopup(false)
            setDeleteData(null)
        }
    }

    const handleIsPost = () => {
        setIsPost((value) => !value)
        setDeletePopup(false)
        setDeleteData(null)
    }

    const handelDeleteClick = () => {
        setLoader(true)

        const data = {
            SeminarID: deleteData?.seminarID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            setloader: setLoader,
        }

        dispatch(M_SeminarMaster_DeleteAPI({ data }))
    }

    return (
        <>
            {isLoading && <LogoLoader />}
            <div className="container-scroller ms-2 custom" style={{ backgroundColor: "#ececec" }}>
                <div className="row background_main_all px-1">
                    <AdminHeader toggle={toggle} isopen={isOpen} />

                    <div className="container-fluid page-body-wrapper mx-0">
                        <AdminSidebar isopen={isOpen} setIsOpen={setIsOpen} active="dashboard" />

                        <div
                            className="main-panel"
                            style={{ width: isOpen ? "" : "calc(100% - 1px)", marginLeft: isOpen ? "" : "1px" }}
                        >
                            <div className="content-wrapper px-3">
                                <div className="col-12">
                                    <div className="shadows bg-white row rounded p-3">
                                        <div className="card shadow-sm py-2 mb-3">
                                            <div className="d-flex justify-content-between align-items-center col-12 pt-0 border-bottom pb-2 mb-2">
                                                <h5 className="fw-bold mb-0 screen-title">Upcoming Seminar</h5>
                                                <button type="button" className="btn btn-primary text-nowrap"
                                                    onClick={() => handleUpcomingSeminarPopUp(true, "add", "")}>
                                                    <Plus size={18} className="me-1" /> Add
                                                </button>
                                            </div>

                                            <div className="d-flex flex-wrap align-items-center justify-content-start gap-3 pb-2">
                                                {/* <DummyDDL label="Title : " compact /> */}
                                                <div className="d-flex align-items-center gap-2">
                                                    <label htmlFor="seminarTitle" className="form-label mb-0 text-nowrap">Title :</label>
                                                    <input
                                                        id="seminarTitle"
                                                        type="text"
                                                        className="form-control"
                                                        value={searchTitle}
                                                        onChange={(event) => setSearchTitle(event.target.value)}
                                                    />
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    <label htmlFor="seminarFromDate" className="form-label mb-0 text-nowrap">From Date :</label>
                                                    <input
                                                        id="seminarFromDate"
                                                        type="date"
                                                        className="form-control"
                                                        value={fromDate}
                                                        min={selectedMonthDateRange.fromDate}
                                                        max={selectedMonthDateRange.toDate}
                                                        onChange={(event) => setFromDate(event.target.value)}
                                                    />
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    <label htmlFor="seminarToDate" className="form-label mb-0 text-nowrap">To Date :</label>
                                                    <input
                                                        id="seminarToDate"
                                                        type="date"
                                                        className="form-control"
                                                        value={toDate}
                                                        min={fromDate || selectedMonthDateRange.fromDate}
                                                        max={selectedMonthDateRange.toDate}
                                                        onChange={(event) => setToDate(event.target.value)}
                                                    />
                                                </div>
                                                <button type="button" className="btn btn-secondary text-nowrap" onClick={handleSearch}>
                                                    <Search size={18} className="me-1" />
                                                    Search
                                                </button>
                                                <button type="button" className="btn btn-danger text-nowrap" onClick={handleClearSearch}>
                                                    <X size={18} className="me-1" />
                                                    Clear
                                                </button>
                                            </div>
                                        </div>

                                        <div className="table-responsive px-0">
                                            <table id="customers">
                                                <thead>
                                                    <tr>
                                                        <th>Sr. No.</th>
                                                        <th>
                                                            <div>Title of Seminar</div>
                                                            <div className="border-top mt-1 pt-1">Sub Title of Seminar</div>
                                                        </th>
                                                        <th>
                                                            <div>Day</div>
                                                            <div className="border-top mt-1 pt-1">Date</div>
                                                        </th>
                                                        <th>Time</th>
                                                        <th>
                                                            <div>Description</div>
                                                            <div className="border-top mt-1 pt-1">Key Topics</div>
                                                        </th>
                                                        <th>
                                                            <div>From Date</div>
                                                            <div className="border-top mt-1 pt-1">To Date</div>
                                                        </th>
                                                        <th className="text-nowrap">
                                                            <div>Seminar Photo</div>
                                                            <div className="border-top mt-1 pt-1">Side Photo</div>
                                                        </th>
                                                        <th>
                                                            <div>Registration Link</div>
                                                            <div className="border-top mt-1 pt-1">Meeting Link</div>
                                                        </th>
                                                        <th className="seminar-action-column">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {TableData && TableData?.length > 0 ? TableData.map((item) => (
                                                        <tr key={item.seminarID}>
                                                            <td align="center" className="cust-min-width-30">{item.rowNum ? item.rowNum : "-"}</td>
                                                            <td align="left" className="text-capitalize cust-min-width-180">
                                                                <ExpandableText value={item.title} />
                                                                <div className="border-top mt-1 pt-1">
                                                                    <ExpandableText value={item.subTitle} />
                                                                </div>
                                                            </td>
                                                            <td align="center" className="cust-min-width-100">
                                                                <div>{item.selectDay ? item.selectDay : "-"}</div>
                                                                <div className="border-top mt-1 pt-1">
                                                                    {item.seminarDate ? moment(item.seminarDate).format("DD/MM/YYYY") : "-"}
                                                                </div>
                                                            </td>
                                                            <td align="center" className="cust-min-width-150">
                                                                {item.startTime && item.endTime
                                                                    ? `${moment(item.startTime, "HH:mm:ss").format("hh:mm A")} - ${moment(item.endTime, "HH:mm:ss").format("hh:mm A")}`
                                                                    : "-"}
                                                            </td>
                                                            <td align="left" className="cust-min-width-180">
                                                                <ExpandableText value={item.description} />
                                                                <div className="border-top mt-1 pt-1">
                                                                    <ExpandableText value={item.keyTopics} />
                                                                </div>
                                                            </td>
                                                            <td align="center" className="cust-min-width-100">
                                                                <div>{item.fromDate ? moment(item.fromDate).format("DD/MM/YYYY") : "-"}</div>
                                                                <div className="border-top mt-1 pt-1">
                                                                    {item.toDate ? moment(item.toDate).format("DD/MM/YYYY") : "-"}
                                                                </div>
                                                            </td>
                                                            <td align="center">
                                                                <div className="mb-1">
                                                                    {item.seminarPicView || item.seminarPhotoPath ? (
                                                                        <button type="button" title="Seminar Photo" className="btn btnSmall btn-link p-0 seminar-table-photo-btn py-0"
                                                                            onClick={() => openPhoto(item.seminarPicView || item.seminarPhotoPath)} aria-label={`Open seminar photo for ${item.title}`}>
                                                                            <div className="" style={{ width: "18px", height: "18px", maxWidth: "18px" }}>
                                                                                <img src="/Static/Assets/Img/seminarPicView.png" alt={`View ${item.title} seminar photo`} className="seminar-table-photo w-100 h-100 object-fit-contain" />
                                                                            </div>
                                                                        </button>
                                                                    ) : "-"}
                                                                </div>
                                                                <div className="border-top mt-1 pt-1">
                                                                    {item.sidePicView || item.sidePhotoPath ? (
                                                                        <button type="button" title="Side Photo" className="btn btnSmall btn-link p-0 seminar-table-photo-btn py-0"
                                                                            onClick={() => openPhoto(item.sidePicView || item.sidePhotoPath)} aria-label={`Open side photo for ${item.title}`}>
                                                                            <div className="" style={{ width: "18px", height: "18px", maxWidth: "18px" }}>
                                                                                <img src="/Static/Assets/Img/sidePicView.png" alt={`View ${item.title} side photo`} className="seminar-table-photo w-100 h-100 object-fit-contain" />
                                                                            </div>
                                                                        </button>
                                                                    ) : "-"}
                                                                </div>
                                                            </td>
                                                            <td align="center" className="cust-min-width-150">
                                                                <div>
                                                                    {item.registerLink ? (
                                                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                                                            <button type="button" className="btn btnSmall btn-link p-0 pe-2"
                                                                                onClick={() => openTextPopup("Register for Seminar", item.registerLink)} aria-label={`View registration link for ${item.title}`} title="View registration link">
                                                                                <Eye size={16} className="text-dark" />
                                                                            </button>
                                                                            <button type="button" className="btnSmall border-start ps-3 btn btn-link p-0"
                                                                                onClick={() => openLink(item.registerLink)} aria-label={`Open registration link for ${item.title}`} title="Open registration link">
                                                                                <Link size={16} className="text-dark" />
                                                                            </button>
                                                                        </div>
                                                                    ) : "-"}
                                                                </div>
                                                                <div className="border-top mt-1 pt-1">
                                                                    {item.meetingLink ? (
                                                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                                                            <button type="button" className="btn btnSmall btn-link p-0 pe-2"
                                                                                onClick={() => openTextPopup("Meeting Link", item.meetingLink)} aria-label={`View meeting link for ${item.title}`} title="View meeting link">
                                                                                <Eye size={16} className="text-dark" />
                                                                            </button>
                                                                            <button type="button" className="btnSmall border-start ps-3 btn btn-link p-0"
                                                                                onClick={() => openLink(item.meetingLink)} aria-label={`Open meeting link for ${item.title}`} title="Open meeting link">
                                                                                <Link size={16} className="text-dark" />
                                                                            </button>
                                                                        </div>
                                                                    ) : "-"}
                                                                </div>
                                                            </td>
                                                            <td align="center" className="seminar-action-column">
                                                                <div className="d-inline-flex align-items-center justify-content-center gap-1">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success seminar-action-btn d-inline-flex align-items-center justify-content-center gap-2"
                                                                        aria-label={`View ${item.title}`}
                                                                        title="View seminar"
                                                                        onClick={() => handleUpcomingSeminarViewPopup(item)}
                                                                    >
                                                                        <Eye size={15} />
                                                                        {/* View */}
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary seminar-action-btn d-inline-flex align-items-center justify-content-center gap-2"
                                                                        aria-label={`Edit ${item.title}`}
                                                                        title="Edit seminar"
                                                                        onClick={() => handleUpcomingSeminarPopUp(true, "edit", item)}
                                                                    >
                                                                        <Edit2 size={15} />
                                                                        {/* Update */}
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger seminar-action-btn d-inline-flex align-items-center justify-content-center gap-2"
                                                                        aria-label={`Delete ${item.title}`}
                                                                        title="Delete seminar"
                                                                        onClick={() => handleDelete(item)}
                                                                    >
                                                                        <Trash2 size={15} />
                                                                        {/* Delete */}
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan={9}>No Data Found ...</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="col-12 pt-3 px-0">
                                            {TableData && TableData?.length > 0 && (
                                                <Pegination
                                                    PerPageCount={perPageCount}
                                                    TotalCount={TableData[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setRowNo}
                                                    CurrentPage={currentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {UpcomingSeminarHoldPopUp.show && (
                <UpcomingSeminarPopup
                    UpcomingSeminarData={UpcomingSeminarHoldPopUp}
                    cancelbtn={handleUpcomingSeminarPopUpClose}
                    heading="Upcoming Seminar"
                    IsPost={isPost}
                    setIsPost={setIsPost}
                />
            )}

            {upcomingSeminarViewPopup.show && (
                <UpcomingSeminarViewPopup
                    UpcomingSeminarData={upcomingSeminarViewPopup}
                    cancelbtn={handleUpcomingSeminarViewPopupClose}
                />
            )}

            {imageViewUrl && (
                <ImageViewPopup
                    imageUrl={imageViewUrl}
                    alt="Seminar photo preview"
                    onClose={() => setImageViewUrl("")}
                />
            )}

            {textViewData.show && (
                <TextViewPopup
                    title={textViewData.title}
                    text={textViewData.text}
                    links={textViewData.links}
                    onClose={() => setTextViewData({ show: false, title: "", text: "", links: [] })}
                />
            )}

            {DeletePopup &&
                <DeletePopupModal
                    confirmBtnCallBack={handelDeleteClick}
                    deleteRecord={deleteData}
                    loader={loader}
                    message="Are you sure, you want to delete this seminar?"
                    cancelBtnCallBack={handleDeleteClose}
                    heading="Delete"
                />
            }
        </>
    )
}
